import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {IHolidayDetailTourItinerary} from '../../interfaces/iholiday-detail-tour-itinerary';
import {TourStopMarkersPipe} from '../../pipes/tour-stop-markers.pipe';

@Component({
  selector: 'app-detail-content-itinerary',
  templateUrl: './detail-content-itinerary.component.html',
  styleUrls: ['./detail-content-itinerary.component.scss']
})
export class DetailContentItineraryComponent implements OnInit {

  selectedDay: any;
  selectedItineraryDay: number;
  bounds: google.maps.LatLngBounds;
  @Input() itinerary: IHolidayDetailTourItinerary[];
  @ViewChild('googleMapRef') googleMapRef;

  constructor(private _tourStopMarkersPipe: TourStopMarkersPipe) { }

  ngOnInit(): void {
  }

  selectDay(day: any): void {
    if (day === this.selectedDay) {
      this.selectedDay = undefined;
    } else {
      this.selectedDay = day;
    }
  }
  
  selectItineraryOnMap(itinerary: IHolidayDetailTourItinerary): void {
    this.selectedItineraryDay = (itinerary.day === this.selectedItineraryDay) ? undefined : itinerary.day;

    for (const indexStop in (itinerary?.stops || [])) {
      itinerary.stops[indexStop].icon = (this.selectedItineraryDay) ? './assets/images/pin_active.png' : undefined;
      itinerary.stops[indexStop].zIndex = (this.selectedItineraryDay) ? 9999 : undefined;
    }
  }

  setBounds(): void {
    if (!this.bounds && this.itinerary?.length > 0) {
      this.bounds =  new google.maps.LatLngBounds();
      this._tourStopMarkersPipe.transform(this.itinerary).forEach(x => {
        this.bounds.extend(x);
      });
      this.googleMapRef.fitBounds(this.bounds);
    }
  }

}
